import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner, Table, Form } from "react-bootstrap";
import axios from "axios";
import { urlBase } from "../../../utils/API";
import { ErrorMsg, success } from "../../../utils/Toast";
import { HomePage } from "../../../translations/trans";
import InfoNote from "../../shared/InfoNote";
import { useSelector } from "react-redux";
const ShowLessonsModal = ({ show, handleClose, userId, selectedClass }) => {
    const [loading, setLoading] = useState(false);
    const [lessons, setLessons] = useState([]);
    const [processing, setProcessing] = useState(null);
    const [unallowedLessons, setUnallowedLessons] = useState([]); // ✅ لتتبع الدروس غير المسموحة

    const {lang,dir} = useSelector(state=>state.language)
    useEffect(() => {
        if (show && selectedClass) {
            setUnallowedLessons(selectedClass.unallowedLessons || []);
            fetchLessons();
        }
    }, [show, selectedClass]);

    const fetchLessons = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${urlBase}/api/package/lessosn/${selectedClass.packID}?userId=${userId}`
            );
            if (res.data?.case) {
                setLessons(res.data.lessons);
            } else {
                setLessons([]);
            }
        } catch (error) {
            console.error("Error fetching lessons:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleLessonToggle = async (lessonId, checked) => {
        setProcessing(lessonId);

        const apiUrl = checked
            ? `${urlBase}/api/class/add-unallowed-lesson/${selectedClass._id}/${lessonId}?userId=${userId}`
            : `${urlBase}/api/class/remove-unallowed-lesson/${selectedClass._id}/${lessonId}?userId=${userId}`;

        try {
            await axios.post(apiUrl, {});

            // ✅ تحديث الواجهة محليًا بدون إعادة تحميل
            setUnallowedLessons((prev) =>
                checked
                    ? [...prev, lessonId] // لو ضافه
                    : prev.filter((id) => id !== lessonId) // لو أزاله
            );

            success(
                checked
                    ? "Lesson disallowed successfully"
                    : "Lesson allowed successfully"
            );
        } catch (error) {
            console.error("Error updating lesson:", error);
            ErrorMsg(error?.response?.data?.message);
        } finally {
            setProcessing(null);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>{HomePage.controlLessons[lang]}</Modal.Title>
                <InfoNote note={'deactivate lessons for all class'}/>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center py-4">
                        <Spinner animation="border" />
                    </div>
                ) : lessons.length > 0 ? (
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Lesson Name</th>
                                <th>Material Code</th>
                                <th>Disallow</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lessons.map((lesson, idx) => (
                                <tr
                                    key={lesson._id}
                                    className={
                                        unallowedLessons.includes(lesson._id)
                                            ? "table-danger"
                                            : ""
                                    } // 💡 لو عايز تلوّن الصف
                                >
                                    <td>{idx + 1}</td>
                                    <td>{lesson.name}</td>
                                    <td>{lesson.materialCode}</td>
                                    <td>
                                        <Form.Check
                                            type="checkbox"
                                            checked={unallowedLessons.includes(
                                                lesson._id
                                            )}
                                            disabled={processing === lesson._id}
                                            onChange={(e) =>
                                                handleLessonToggle(
                                                    lesson._id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p className="text-center text-muted">No lessons found.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ShowLessonsModal;
